import { Component, createRef } from "react";
import { IBaseComponentProps, NSBoxEntity } from "namirasoft-site-react";
import { PolicyRow } from "namirasoft-access";
import { AccessProps } from "../AccessProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { SortItem } from "namirasoft-core";

export interface PolicyLineProps extends IBaseComponentProps, NSARouterMakerResult, AccessProps
{
	index: number;
	deletable: boolean;
	fullWidth?: boolean;
	onDelete: () => void;
	onChanged?: (value: any) => void;
}

export default class PolicyLine extends Component<PolicyLineProps>
{
	static IS_DIRTY(value: any): boolean
	{
		if (value)
			return true;
		return false;
	}

	private NSBoxEntity_Policy = createRef<NSBoxEntity<PolicyRow>>();

	constructor(props: PolicyLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError?: boolean): string
	{
		return this.NSBoxEntity_Policy.current?.getValueOne(checkError) ?? "";
	}

	setValue(value: string)
	{
		this.NSBoxEntity_Policy.current?.setValue(value);
	}

	isDirty(): boolean
	{
		return PolicyLine.IS_DIRTY(this.getValue());
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue());
	}

	override render()
	{
		let namirasoft = new NamirasoftMap(this.props.account.token_manager, console.error);

		return (
			<NSBoxEntity<PolicyRow>
				ref={this.NSBoxEntity_Policy}
				{...this.props}
				title={`Policy ${this.props.index + 1}`}
				required={false}
				multiple={false}
				table={namirasoft.access.tables.policy}
				getValue={item => item.id}
				getTitle={item =>
				{
					return item.name + (item.user_id == null ? " (Global)" : "");
				}}
				getSort={() =>
				{
					return new SortItem(namirasoft.access.tables.policy, namirasoft.access.tables.policy.columns.name, true);
				}}
				onChanged={this.onChanged}
				style={{ ...this.props.style, width: "100%" }}
				menu={{
					builtin: {
						delete: {
							enabled: this.props.deletable,
							onDelete: () => { this.props.onDelete(); }
						}
					},
					items: []
				}}
			/>
		);
	}
}